import React, { createContext, useContext, useState } from 'react';

interface SummaryItem {
  title: string;
  content: string;
  summaryId: string;
  timestamp: number;
}

interface ChartSummaryContextType {
  summaries: SummaryItem[];
  addSummary: (title: string, content: string, summaryId?: string) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  isSplitPanelOpen: boolean;
  setIsSplitPanelOpen: (open: boolean) => void;
  clearSummaries: () => void;
}

export const ChartSummaryContext = createContext<ChartSummaryContextType>({
  summaries: [],
  addSummary: () => {},
  isLoading: false,
  setIsLoading: () => {},
  isSplitPanelOpen: false,
  setIsSplitPanelOpen: () => {},
  clearSummaries: () => {}
});

export const useChartSummaryContext = () => useContext(ChartSummaryContext);
